export default __webpack_public_path__ + "static/media/BKPM NEW 1.efd97c7d.png";